/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FAnonymousType112
 */
export interface FAnonymousType112 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType112
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType112
     */
    name?: string | null;
}

/**
 * Check if a given object implements the FAnonymousType112 interface.
 */
export function instanceOfFAnonymousType112(value: object): value is FAnonymousType112 {
    return true;
}

export function FAnonymousType112FromJSON(json: any): FAnonymousType112 {
    return FAnonymousType112FromJSONTyped(json, false);
}

export function FAnonymousType112FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType112 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function FAnonymousType112ToJSON(json: any): FAnonymousType112 {
    return FAnonymousType112ToJSONTyped(json, false);
}

export function FAnonymousType112ToJSONTyped(value?: FAnonymousType112 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

